import { definitionsFromContext } from 'stimulus/webpack-helpers';
import application from 'stimulus_application';
import './hero.css';
const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
